/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react'

import config from 'config'
import { useBrandConfig } from 'contexts/BrandConfigContextProvider'
import useUser from 'hooks/useUser'

import Chart from '../Chart'
import { DashboardItemProps } from '../types'
import {
    BoardAutoContainer,
    BoardAppStatistics,
    BoardAppStats,
    BoardAutoChart,
    BoardAppStat,
    BoardFundedStatistics,
    BoardFundedStats,
    BoardFundedStat,
    BoardIFrame,
} from './AutoBoard.styled'

function AutoBoard({ componentStyle, data }: DashboardItemProps) {
    const brandExperienceConfig = useBrandConfig()
    const { user } = useUser()
    // Create marketing iframe URL from brand config news URL
    // Fall back to hardcoded config if newsPathUrl is not available
    const trimmedNewsPathUrl = brandExperienceConfig.newsPathUrl?.trim()

    let marketingIFrameUrl =
        trimmedNewsPathUrl && trimmedNewsPathUrl.length > 0
            ? `${config.NEWS_IFRAME_BASE_URL}/${trimmedNewsPathUrl}`
            : config.AUTO_BOARD_MARKETING_CONTENT

    const dealershipMarketingIframeUrl =
        user?.dealership?.dealerPortalMarketingIframeUrl

    if (brandExperienceConfig.isDefault && dealershipMarketingIframeUrl) {
        marketingIFrameUrl = dealershipMarketingIframeUrl
    }

    return (
        <BoardAutoContainer componentStyle={componentStyle}>
            <BoardFundedStatistics>
                <BoardFundedStats>
                    {data.statistics.fundedItems.map(
                        (stat: any, index: number) => {
                            return (
                                <BoardFundedStat key={index}>
                                    <strong>{stat.value}</strong>
                                    <span>{stat.label}</span>
                                </BoardFundedStat>
                            )
                        },
                    )}
                </BoardFundedStats>
            </BoardFundedStatistics>
            <BoardAppStatistics>
                <BoardAppStats>
                    {data.statistics.items.map((stat: any, index: number) => {
                        return (
                            <BoardAppStat key={index}>
                                <strong>{stat.value}</strong>
                                <span>{stat.label}</span>
                            </BoardAppStat>
                        )
                    })}
                </BoardAppStats>
            </BoardAppStatistics>
            <BoardIFrame>
                <iframe
                    src={marketingIFrameUrl}
                    scrolling="false"
                    title="marketing_frame"
                />
            </BoardIFrame>
            <BoardAutoChart>
                <h5>
                    {data.chart.title}
                    <small>
                        <strong>{data.chart.totalFunded}</strong>{' '}
                        {data.chart.label}
                    </small>
                </h5>
                <Chart data={data.chart.data} />
            </BoardAutoChart>
            <footer>
                <h5>{data.footer.title}</h5>
                {data.footer.stats.map((stat: any, index: number) => {
                    return (
                        <div className="stat" key={index}>
                            <b>{stat.title}</b>
                            <strong>{stat.value}</strong>
                            <span>{stat.description}</span>
                        </div>
                    )
                })}
            </footer>
        </BoardAutoContainer>
    )
}

export default AutoBoard
